import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "작성일", "제개정일", "첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "공장명",
        key: "body.subInfo.공장명",
      },
      {
        name: "구분",
        key: "body.subInfo.구분",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "Rev",
        key: "body.subInfo.rev",
      },
      {
        name: "제개정일",
        key: "body.subInfo.제개정일",
      },
      {
        name: "첨부",
        key: "body.fileList",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).subInfo.공장명; // 공장명
        case 3:
          return func.getContent(value).subInfo.구분; // 구분
        case 4:
          return func.getCreatedDate(value.created_at); // 작성일
        case 5: {
          // rev
          if (!func.getContent(value).subInfo.rev || func.getContent(value).subInfo.rev === 0) {
            return "비대상";
          }
          return func.getContent(value).subInfo.rev;
        }
        case 6:
          return func.getContent(value).subInfo.제개정일; // 제개정일
        case 7: {
          // 첨부
          const files = func.getContent(value).fileList;
          if (files.length === 0) return "-";
          const latestFile = files[0];
          latestFile.fileName = latestFile.fileName || latestFile.name;
          return {
            type: "docs",
            file: latestFile,
          };
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
